import { SimpleGenList } from '../simpleGenList';

/**
 * Months of the year in Czech.
 * Port of C# Seznam_Mesice__CS.
 */
export class GenList_Months__CS extends SimpleGenList {
  constructor() {
    super(
      'leden',
      'únor',
      'březen',
      'duben',
      'květen',
      'červen',
      'červenec',
      'srpen',
      'září',
      'říjen',
      'listopad',
      'prosinec'
    );
  }
}

/**
 * Months of the year in English.
 * Port of C# Seznam_Mesice__EN.
 */
export class GenList_Months__EN extends SimpleGenList {
  constructor() {
    super(
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    );
  }
}

/**
 * Months of the year in German.
 * Port of C# Seznam_Mesice__DE.
 */
export class GenList_Months__DE extends SimpleGenList {
  constructor() {
    super(
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    );
  }
}

/**
 * Months of the year in Spanish.
 * Port of C# Seznam_Mesice__ES.
 */
export class GenList_Months__ES extends SimpleGenList {
  constructor() {
    super(
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    );
  }
}

/**
 * Months of the year in French.
 * Port of C# Seznam_Mesice__FR.
 */
export class GenList_Months__FR extends SimpleGenList {
  constructor() {
    super(
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre'
    );
  }
}

/**
 * Months of the year in Latin.
 * Port of C# Seznam_Mesice__LA.
 */
export class GenList_Months__LA extends SimpleGenList {
  constructor() {
    super(
      'Ianuarius',
      'Februarius',
      'Martius',
      'Aprilis',
      'Maius',
      'Iunius',
      'Iulius',
      'Augustus',
      'September',
      'October',
      'November',
      'December'
    );
  }
}

/**
 * Months of the year in Russian.
 * Port of C# Seznam_Mesice__RU.
 */
export class GenList_Months__RU extends SimpleGenList {
  constructor() {
    super(
      'январь',
      'февраль',
      'март',
      'апрель',
      'май',
      'июнь',
      'июль',
      'август',
      'сентябрь',
      'октябрь',
      'ноябрь',
      'декабрь'
    );
  }
}

/**
 * Months of the year in Slovak.
 * Port of C# Seznam_Mesice__SK.
 */
export class GenList_Months__SK extends SimpleGenList {
  constructor() {
    super(
      'január',
      'február',
      'marec',
      'apríl',
      'máj',
      'jún',
      'júl',
      'august',
      'september',
      'október',
      'november',
      'december'
    );
  }
}
